import React from "react";
import fields from "../../json/ProductListFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";


const AddProductForm = ({ values, errors, handleChange, handleSubmit, loading, title = "Create Product", CategoryOPction = [], UOMOpction = [] }) => {
  const { formdata } = fields;

  return (
    <PageBody headerchildren={<HeadingOne>{title}</HeadingOne>} onSubmit={handleSubmit}>
      {formdata.map((field) => {
        if (field.type === "switch") {
          return <Switch key={field.name} values={values[field.name]} handleChange={handleChange} field={field} ValueOne="1" ValueTwo="0" LabelOne="Active" LabelTwo="Inactive" />;
        }
        if (field.type === "select") {
          let options = [];
          if (field.name === "category_id") {
            options = CategoryOPction.map((opt) => ({
              value: opt.category_id,
              label: opt.categoryname
            }));
          } else if (field.name === "uom_id") {
            options = UOMOpction.map((opt) => ({
              value: opt.id,
              label: opt.uom_name
            }));
          }
          return <FormSelect key={field.name} field={field} value={values[field.name]} handleChange={handleChange} options={options} error={errors[field.name]} />;
        }

        return <FormInput key={field.name} field={field} value={values[field.name]} handleChange={handleChange} error={errors[field.name]} />;
      })}

      <FormSubmitButton label={`Create`} loading={loading} colSize="col-12" align="end" />
    </PageBody>
  );
};
    
export default AddProductForm;
